import React from 'react';
import { Avatar } from '../../shared/Avatar';
import { MasteryBar } from '../../shared/MasteryBar';
import type { SchoolData } from './types';
interface SchoolDetailPanelProps {
  school: SchoolData;
}
export function SchoolDetailPanel({
  school
}: SchoolDetailPanelProps) {
  return <div className="space-y-6" data-id="element-6527">
      <div className="grid grid-cols-3 gap-3" data-id="element-6528">
        <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-6529">
          <div className="text-2xl font-bold text-purple-700" data-id="element-6530">
            {school.learnerCount}
          </div>
          <div className="text-xs text-purple-600" data-id="element-6531">Leerlingen</div>
        </div>
        <div className="bg-indigo-50 rounded-lg p-3 text-center" data-id="element-6532">
          <div className="text-2xl font-bold text-indigo-700" data-id="element-6533">
            {school.teacherCount}
          </div>
          <div className="text-xs text-indigo-600" data-id="element-6534">Docenten</div>
        </div>
        <div className="bg-emerald-50 rounded-lg p-3 text-center" data-id="element-6535">
          <div className="text-2xl font-bold text-emerald-700" data-id="element-6536">
            {school.avgMastery}%
          </div>
          <div className="text-xs text-emerald-600" data-id="element-6537">Gem. beheersing</div>
        </div>
      </div>

      {school.teachers.length > 0 && <div data-id="element-6538">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-6539">Docenten</h3>
          <div className="space-y-1" data-id="element-6540">
            {school.teachers.map(t => <div key={t.id} className="flex items-center gap-2 py-1.5" data-id="element-6541">
                <Avatar name={t.name} data-id="element-6542" />
                <span className="text-sm text-gray-700" data-id="element-6543">{t.name}</span>
              </div>)}
          </div>
        </div>}

      {school.learners.length > 0 && <div data-id="element-6544">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-6545">
            Leerlingen
          </h3>
          <div className="space-y-2" data-id="element-6546">
            {school.learners.map(learner => <div key={learner.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-id="element-6547">
                <div className="flex items-center gap-2" data-id="element-6548">
                  <Avatar name={learner.name} data-id="element-6549" />
                  <div data-id="element-6550">
                    <div className="text-sm text-gray-800" data-id="element-6551">{learner.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-6552">
                      {learner.account && 'grade' in learner.account ? `Groep ${learner.account.grade}` : '—'}{' '}
                      · {learner.sessionCount} sessies
                    </div>
                  </div>
                </div>
                <MasteryBar value={learner.avgMastery || 0} data-id="element-6553" />
              </div>)}
          </div>
        </div>}
    </div>;
}